import CountryJson from './country.json';
import flags from 'react-phone-number-input/flags';

export const getAllCountries = () => {
  return CountryJson;
};

export const getCountryByCountryCode = (countryCode) => {
  if (!countryCode) return null;
  return CountryJson.find(({ isoCode }) => isoCode === countryCode);
};

export const getCountryByPhoneCode = (code) => {
  return CountryJson.find(({ phonecode }) => phonecode === code);
};

export const getTimezonesByCountryCode = (countryCode) => {
  return CountryJson.find(({ isoCode }) => isoCode === countryCode)?.timezones;
};

export const GetFlagWithCountryCode = ({ iso = 'IN', className = '' }) => {
  const flag = flags[iso];
  if (flag) {
    return flags[iso]({ title: iso });
  }
  return null;
};

export const GetCountryNameWithFlag = (iso) => {
  const allCountries = getAllCountries();
  const country = allCountries?.find((val) => val?.isoCode === iso);
  if (iso) {
    return (
      <div className="flagBox d--flex align-items--center gap--sm">
        <div className="w-min--28 d--flex">
          {GetFlagWithCountryCode({ iso })}
        </div>
        <div className="d--flex justify-content--center font--400 font--sm">
          {country.name}
        </div>
      </div>
    );
  }
};

export const GetNumberWithFlag = ({iso, number}) => {
  const allCountries = getAllCountries();
  const country = allCountries?.find((val) => val?.isoCode === iso);
  if (iso) {
    return (
      <div className="flagBox d--flex align-items--center gap--sm">
        <div className="w-min--28 d--flex">
          {GetFlagWithCountryCode({ iso })}
        </div>
        <div className="d--flex justify-content--center font--400 font--sm">
          {number}
        </div>
      </div>
    );
  }
};


// "name": "Dominican Republic",
//     "isoCode": "DO",
//     "flag": "🇩🇴",
//     "phonecode": "+1-809 and 1-829",

// "name": "Puerto Rico",
// "isoCode": "PR",
// "flag": "🇵🇷",
// "phonecode": "+1-787 and 1-939",